<template>
  <div id="app">
    <Header />
    <Navbar v-if="$store.isSignedIn" />
    <div v-else class="no-user"></div>
    <div class="rout-container">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
export default {
  components: {
    Header,
    Navbar,
    Footer,
  },
  data() {
    return {
      //check user signed in
    };
  },
  created() {
    this.$store.isSignedIn = localStorage.isSignedIn == "true";
  },
};
</script>
<style>
:root {
  --primary-color: #9c0e16;
  --black: #212529;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
}

.rout-container {
  flex-grow: 1;
}

.visible {
  visibility: visible;
  opacity: 1;
  transition: opacity 2s linear;
}
.hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 2s, opacity 2s linear;
}
.action {
  width: 30px;
  height: 30px;
  border: none;
  outline: none;
  background: none;
  font-size: 20px;
}

.component-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: sticky;
  top: 60px;
  background: white;
  z-index: 1001;
}
.no-user {
  min-height: 62px;
  background: var(--gray-dark);
}
.failed-warning {
  margin-top: 5px;
  color: red;
}

</style>
